const routes = [
	{
		name: 'receiving.index',
		path: '/receiving/:id',
		component: () => import(/* webpackChunkName: 'receiving' */ './views/ReceivingIndex'),
	},
]

export default routes
